import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as L from 'leaflet';

@Component({
  selector: 'app-location-open-map',
  templateUrl: './location-open-map.component.html',
  styleUrls: ['./location-open-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LocationOpenMapComponent implements AfterViewInit {

  @ViewChild('mapDetail', { static: false }) mapElement!: ElementRef;
  map!: L.Map;
  marker!: L.Marker;
  addressInput: string = '';
  addressOriginal: string = '';
  dinamicAddress: string = '';
  location = { lat: 0, lng: 0 };
  loadSave = false;
  activeReplace = false

  constructor(
    private http: HttpClient,
    public dialogRef: MatDialogRef<LocationOpenMapComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit(): void {
    this.initMap();
    this.updateMapWithData(this.data);
  }

  private initMap(): void {
    this.map = L.map('mapDetail').setView([14.5995, -90.577], 12); // Coordenadas iniciales

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors',
    }).addTo(this.map);

    let color_route = '#27499e';
    const routeIcon = L.divIcon({
      html: `<span class="svg-icon svg-icon-danger svg-icon-3x">
        <svg fill=${color_route} viewBox="0 0 297 297" style="enable-background:new 0 0 297 297;" xml:space="preserve">
        <path d="M148.5,0C87.43,0,37.747,49.703,37.747,110.797c0,91.026,99.729,179.905,103.976,183.645
        c1.936,1.705,4.356,2.559,6.777,2.559c2.421,0,4.841-0.853,6.778-2.559c4.245-3.739,103.975-92.618,103.975-183.645
        C259.253,49.703,209.57,0,148.5,0z M148.5,79.693c16.964,0,30.765,13.953,30.765,31.104c0,17.151-13.801,31.104-30.765,31.104
        c-16.964,0-30.765-13.953-30.765-31.104C117.735,93.646,131.536,79.693,148.5,79.693z"/>
        </svg></span>`,
      iconSize: [30, 30],
      iconAnchor: [15, 20],
      className: 'leaflet-marker',
    });

    this.marker = L.marker([14.5995, -90.577], { draggable: true, icon: routeIcon }).addTo(this.map);

    // Evento para actualizar coordenadas cuando se mueve el marcador
    this.marker.on('dragend', (event: any) => {
      const position = event.target.getLatLng();
      this.updateLocation(position.lat, position.lng);
    });
  }

  updateMapWithData(data: any): void {
    if (data.latitude && data.longitude) {
      const lat = parseFloat(data.latitude);
      const lng = parseFloat(data.longitude);

      this.map.setView([lat, lng], 15);
      this.marker.setLatLng([lat, lng]);
      this.updateLocation(lat, lng);

      this.addressInput = data.address || `${data.city}, ${data.dep}, ${data.country}`;
      this.addressOriginal = data.address || `${data.city}, ${data.dep}, ${data.country}`;
      this.dinamicAddress = this.addressInput

    } else {
      console.error('Datos inválidos para actualizar el mapa');
    }
  }

  changeCheck(e: any) {
    this.activeReplace = e.checked
    this.changeAddres()
  }

  changeAddres() {
    if (this.activeReplace) {
      this.dinamicAddress = this.addressInput
    } else {
      this.dinamicAddress = this.addressOriginal
    }
  }

  updateLocation(lat: number, lng: number): void {
    this.location = { lat, lng };
  }

  searchLocation(): void {
    if (!this.addressInput) return;

    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
      this.addressInput
    )}`;

    this.http.get<any[]>(url).subscribe((response: any) => {
      if (response.length > 0) {
        const { lat, lon } = response[0];

        this.map.setView([+lat, +lon], 12);
        this.marker.setLatLng([+lat, +lon]);
        this.updateLocation(+lat, +lon);
      }
    });
  }

  onSave() {
    this.dialogRef.close({
      address: this.dinamicAddress,
      latitude: this.location.lat,
      longitude: this.location.lng,
    });
  }

  onClose() {
    this.dialogRef.close('Close');
  }
}
